'use strict';

var _ = require('lodash');
var UserFactory = function UserFactory() {
  var User = function User(userData) {
    var self = this;
    _.forOwn(userData, function (value, option) {
      self[option] = value;
    });
  };
  User.prototype.isSabre = function () {
    return _.get(this, 'isSabreEmployee', false);
  };
  User.prototype.getDisplayName = function () {
    if (this.isSabreEmployee) {
      return this.getUserId();
    }
    return _.trim(_.get(this, 'firstName', '') + ' ' + _.get(this, 'lastName', ''));
  };
  User.prototype.getUserId = function () {
    return _.get(this, 'userId', 'AVRO');
  };
  User.prototype.getMarketPreferences = function () {
    var marketsPreferences = _.get(this, 'preferences.markets', []);
    return !!marketsPreferences.length && marketsPreferences;
  };
  User.prototype.getLegsPreferences = function () {
    var legsPreferences = _.get(this, 'preferences.legs', []);
    return !!legsPreferences.length && legsPreferences;
  };
  User.prototype.getUserPrivileges = function () {
    return _.get(this, 'privileges', []);
  };
  User.prototype.getWorkflowSettings = function () {
    return _.get(this, ['preferences', 'workflowSettings'], {});
  };
  User.prototype.getDateTimeSettings = function () {
    return _.get(this, ['preferences', 'dateTimeNumberFormatSettings'], []);
  };
  User.prototype.getMarketResponsibilities = function () {
    var marketsPreferences = _.get(this, 'responsibilities.markets', []);
    return !!marketsPreferences.length && marketsPreferences;
  };
  User.prototype.getLegsResponsibilities = function () {
    var legsPreferences = _.get(this, 'responsibilities.legs', []);
    return !!legsPreferences.length && legsPreferences;
  };
  User.prototype.addMarket = function (market, where) {
    where = where || 'responsibilities';
    var marketList = _.get(this, [where, 'markets']);
    if (marketList && !_.includes(marketList, market)) {
      marketList.push(market);
    }
  };
  User.prototype.addLeg = function (leg, where) {
    where = where || 'responsibilities';
    var legList = _.get(this, [where, 'legs']);
    if (legList && !_.includes(legList, leg)) {
      legList.push(leg);
    }
  };
  User.prototype.removeMarket = function (market, where) {
    where = where || 'responsibilities';
    var marketList = _.get(this, [where, 'markets']);
    if (marketList && _.includes(marketList, market)) {
      return _.remove(marketList, function (m) {
        return m === market;
      });
    }
  };
  User.prototype.removeLeg = function (leg, where) {
    where = where || 'responsibilities';
    var marketList = _.get(this, [where, 'legs']);
    if (marketList && _.includes(marketList, leg)) {
      return _.remove(marketList, function (l) {
        return l === leg;
      });
    }
  };
  return User;
};
UserFactory.$inject = [];
module.exports = UserFactory;